import { TimeZone } from '../types/ViewModel/TimeZone';
import { TimeZoneBM } from '../types/BusinessModel/TimeZoneBM';

import { TimeZoneData } from '../types/ViewModel/TimeZoneData';
import { TimeZoneDataBM } from '../types/BusinessModel/TimeZoneDataBM';
import { parseZonelessLocalTimeMs, registerLocalTime } from '../service-worker/offline_handlers/aol/event-time-keys.js';

// The DST boundaries are zoneless port local times. In a browser whose own DST gap contains one (Europe/Oslo 29.03.2026 02:00),
// the Date is shifted (03:00), so the exact local time is remembered on it (event-time-keys.js). The Date value is unchanged.
const toBoundaryDate = (value: Date | string): Date => {
    const date = new Date(value);
    const timeMs = parseZonelessLocalTimeMs(value);
    return timeMs === null ? date : registerLocalTime(date, timeMs);
};

export class TimeZoneFactory {
    constructor() {}

    private newTimeZone(timeZone: TimeZoneBM): TimeZone {
        const dstStartLocalTime = timeZone.dstStartLocalTime ? toBoundaryDate(timeZone.dstStartLocalTime) : null;
        const dstEndLocalTime = timeZone.dstEndLocalTime ? toBoundaryDate(timeZone.dstEndLocalTime) : null;
        return new TimeZone(
            timeZone.timeZoneId,
            timeZone.timeZoneCode,
            timeZone.year,
            dstStartLocalTime,
            dstEndLocalTime,
            timeZone.utcOffset,
            timeZone.utcOffsetDst
        );
    }

    public newTimeZoneArray(timeZoneList: TimeZoneBM[]): TimeZone[] {
        const TimeZoneArray: TimeZone[] = [];
        if (timeZoneList && timeZoneList.length > 0) {
            timeZoneList.map((t) => {
                const timeZone = this.newTimeZone(t);
                TimeZoneArray.push(timeZone);
            });
        }
        return TimeZoneArray;
    }

    public newTimeZoneArrayFromCode(timeZoneList: TimeZone[]): TimeZone[] {
        const TimeZoneArray: TimeZone[] = [];
        if (timeZoneList && timeZoneList.length > 0) {
            timeZoneList.map((t) => {
                const timeZone = new TimeZone(
                    t.timeZoneId,
                    t.timeZoneCode,
                    t.year,
                    t.dstStartLocalTime,
                    t.dstEndLocalTime,
                    t.utcOffset,
                    t.utcOffsetDst
                );
                TimeZoneArray.push(timeZone);
            });
        }
        return TimeZoneArray;
    }

    public newTimeZoneData(timeZoneDataBM: TimeZoneDataBM): TimeZoneData {
        const timeZoneData: TimeZoneData = {};

        Object.keys(timeZoneDataBM).forEach((portIdStr) => {
            const portId = parseInt(portIdStr, 10);
            const timeZoneBMArray = timeZoneDataBM[portId];
            timeZoneData[portId] = this.newTimeZoneArray(timeZoneBMArray);
        });

        return timeZoneData;
    }
}
